const Items = ({ navBtn, bondaAdminBtn, activePointProgram }) => {
  return (
    <>
      {navBtn('usuarios', 'Usuarios', 1)}
      {!activePointProgram && navBtn('programa', 'Programa de puntos', 6)}
      {navBtn('interacciones', 'Interacciones', 2)}
      {navBtn('actividades', 'Actividades', 3)}
      {navBtn('roles', 'Roles y Permisos', 4)}
      {bondaAdminBtn()}
    </>         
  );
};

export default Items;
